import { get, isFunction } from 'lodash'
import React from 'react'

import RouterContext, {
  TContextValue,
  TRouterContextProvider,
} from './RouterContext'

function cleanUrl(url: string): string {
  return url.replace(/\/{2}/, '/')
}

const RouterContextProvider = (
  props: TRouterContextProvider,
): React.ReactElement => {
  const { children, history, location, ...rest } = props

  const appendUrl = (url: string): void => {
    history.push(cleanUrl(`${location.pathname}/${url}`))
  }

  const replaceUrl = (needle: string, w: string): void => {
    const url = cleanUrl(`${location.pathname}`).replace(needle, w)
    history.push(url)
  }

  const contextValue: TContextValue = {
    history,
    location,
    pathname: get(location, 'pathname'),
    appendUrl,
    replaceUrl,
    ...rest,
  }

  return (
    <RouterContext.Provider value={contextValue}>
      {isFunction(children) ? children(contextValue) : children || null}
    </RouterContext.Provider>
  )
}

export default RouterContextProvider
